import React from 'react';
import { connect } from 'react-redux';
import scrollIntoView from 'scroll-into-view';
import FormField from 'shared/components/ui/formField';
import Button from 'shared/components/ui/button';
import * as checkoutActions from './actions';
import { addCart as addToCart } from 'shared/components/cart/actions';
import { isEqual } from 'shared/models/address';

class GiftBag extends React.Component {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  addToCart() {
    this.setState({ loading: true })
    this.props.addToCart(this.props.giftBag).finally(() => {
      this.setState({ loading: false })
    });
  }

  render() {
    const { giftBag } = this.props;

    if (!giftBag.price) return null;

    return (
      <section className="gift-bag__container">
        <div className="gift-bag__image-container">
          <img className="gift-bag__image" src={ giftBag.image } />
        </div>
        <div className="gift-bag__heading">{ giftBag.title }</div>
        <div>{ giftBag.subtitle } | { giftBag.volume } | ${ giftBag.priceDisplay } </div>
        <p className="gift-bag__description">{ giftBag.description }</p>
        <Button
          onClick={() => this.addToCart()}
          disabled={this.state.loading}
          loading={this.state.loading}
          className="btn-primary green btn--full-width gift-bag__btn"
        >
          Add to Cart
        </Button>
      </section>
    )
  }
}

GiftBag = connect(state => ({
  giftBag: state.checkout.giftBag,
  lat: state.address.lat,
  lng: state.address.lng,
  address: state.address
}), {
  addToCart
})(GiftBag);


class GiftInfo extends React.Component {
  componentDidUpdate() {
    if (this.props.giftRecipientError || this.props.giftMobileError) {
      const containerRect = this.container.getBoundingClientRect();
      if (containerRect && containerRect.top < 0) scrollIntoView(this.container);
    }
  }

  render() {
    return (
      <div className="checkout-subsection" ref={(div) => this.container = div}>
        <h3 className="checkout-subsection__title">Gift Info</h3>

        <div className="row">
          <div className="col-xs-12 col-md-7">
            <FormField
              id="gift-info-recipient"
              labelText="Recipient Name"
              initialValue={this.props.giftRecipient}
              onChange={(name) => this.props.setGiftRecipient(name)}
              validate={(name) => this.props.validateRecipient(name)}
              error={this.props.giftRecipientError}
            />
          </div>

          <div className="col-xs-12 col-md-5">
            <FormField
              id="gift-info-phone"
              labelText="Recipient Mobile"
              initialValue={this.props.giftMobile}
              onChange={(number) => this.props.setGiftMobile(number)}
              validate={(number) => this.props.validateMobile(number)}
              error={this.props.giftMobileError}
            />
          </div>

          <div className="col-xs-12">
            <FormField
              textarea
              id="gift-info-note"
              labelText="Gift Note (optional)"
              initialValue={this.props.giftNote}
              onChange={(note) => this.props.setGiftNote(note)}
            />
          </div>

          <div className="col-xs-12">
            <GiftBag />
          </div>
        </div>
      </div>
    )
  }
}

GiftInfo = connect(state => ({
  giftRecipient: state.checkout.giftRecipient,
  giftMobile: state.checkout.giftMobile,
  giftNote: state.checkout.giftNote,
}), {...checkoutActions})(GiftInfo);

export default GiftInfo;



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/gift.js